import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
 
export default function AllergyCategorySkeleton() {
  return (
    <div className="space-y-6 max-w-xl py-8 text-left">
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            name="name"
            type="text"
            aria-describedby="name-error"
            className="bg-gray-100 animate-pulse"
            disabled
          />
        </div>
        
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 rounded-lg bg-gray-100 animate-pulse"></div>
        <div className="h-10 w-32 rounded-lg bg-gray-100 animate-pulse"></div>
      </div>
    </div>
  );
}
